// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCommentOutlinedSvg from "@fishx/icons-svg/es/asn/PCommentOutlined";
import FishxIcon from '../components/FishxIcon';

var PCommentOutlined = function PCommentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCommentOutlinedSvg
  }));
};

PCommentOutlined.displayName = 'PCommentOutlined';
export default React.forwardRef(PCommentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCommentOutlined.js
// module id = 3306
// module chunks = 0